// Lib
import { cloneDeep } from 'lodash/fp';

// Utils
import { dangerouslyUpdatePlatformSingletonDetails, platformSingleton } from './platformSingleton';

// Types
import { UnknownAction } from 'redux';
import {
    PLATFORM_DETAILS_UPDATE,
    PlatformDetails,
    PlatformDetailsUpdateAction,
} from '../../common/platform/platformTypes';
import { PWA_APP_INSTALLED } from '../pwaApp/store/pwaAppConstants';
import { getApplicationType } from './utils/platformInitialisationUtils';

const initialState = cloneDeep(platformSingleton);

const handlePlatformDetailsUpdate = (state: PlatformDetails, action: PlatformDetailsUpdateAction) => {
    dangerouslyUpdatePlatformSingletonDetails(action.details);

    return {
        ...state,
        ...action.details,
    };
};

export default (state = initialState, action: UnknownAction) => {
    switch (action.type) {
        case PLATFORM_DETAILS_UPDATE:
            return handlePlatformDetailsUpdate(state, action as PlatformDetailsUpdateAction);
        case PWA_APP_INSTALLED:
            return {
                ...state,
                appType: getApplicationType(state.capacitorPlatform, state.type, state.formFactor),
            };
        default:
            return state;
    }
};
